import { Button } from "@material-ui/core";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { useState } from "react";
import { activityTableStyle } from "./style";
import BulkUpdateActivityDialog from "./BulkUpdateActivityDialog";

const BulkUpdateActivity = ({
    selectedRows, //Injected by the bulk actions
    activityLogs,
    onClear
}) => {
    const classes = activityTableStyle();

    const [open, setOpen] = useState(false);

    return (
        <>
            <Authorize profile={permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG}>
                <div className={classes.btn}>
                    <Button
                        variant={'text'}
                        disabled={!selectedRows?.length}
                        onClick={() => setOpen(true)}
                        color='primary'>
                        {`Update Activities (${selectedRows?.length})`}
                    </Button>
                </div>
                <BulkUpdateActivityDialog selectedRows={selectedRows} activityLogs={activityLogs} open={open} setOpen={setOpen} onClear={onClear} />
            </Authorize>
        </>
    )
}

export default BulkUpdateActivity;